<kit-page-header [backgroundWhite]="false"
                 [description]="'Download statements containing closed sales and payout history per retailer for a period'"
                 [fullWidthDescription]="true"
                 [section]="'Retailer Transaction Statements'"
                 [title]="'View and download statements for a given period'"
></kit-page-header>

@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="fx-col page-padding page-content fx-gap-20">
  <div>
    <div class="fx-row fx-center fx-space-between fx-gap-10">

      <app-custom-date-filter (dateRange)="getDateRange($event)"
                              [customDateRangePresets]="dateFilters"
                              [initialPreset]="'last_month'"
                              [showBorder]="false"></app-custom-date-filter>

      <mat-form-field class="custom-select-field" appearance="outline" style="width: 30% !important;">
        <mat-select class="custom-select-field-value" [formControl]="retailersCtrl" multiple
                    placeholder="Retailers to export">
          <mat-select-trigger>
            {{ retailersCtrl.value?.[0] || '' }}
            @if ((retailersCtrl.value?.length || 0) > 1) {
              <span class="additional-selection">
        (+{{ (retailersCtrl.value?.length || 0) - 1 }}
                {{ retailersCtrl.value?.length === 2 ? "other" : "others" }})
      </span>
            }
          </mat-select-trigger>
          <mat-option value="select-all" [allValues]="exportRetailerOptions"  selectAll>Select all</mat-option>

          @for (option of exportRetailerOptions; track option) {
            <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button
        mat-icon-button
        [matMenuTriggerFor]="mainOptionsMenu"
        matTooltip="Export Options"
        [disabled]="!!(loading$ | async)"
      >
        <mat-icon class="crud-table-main-toolbar-icon">more_vert</mat-icon>
      </button>
      <mat-menu #mainOptionsMenu="matMenu">
        <!-- Export to Excel -->
        <button mat-menu-item (click)="downloadAsExcel()">
          <mat-icon>file_download</mat-icon>
          <span>Export to Excel</span>
        </button>

        <!-- Export to PDF -->
        <button mat-menu-item (click)="downloadAsPdf()">
          <mat-icon>file_download</mat-icon>
          <span>Export to PDF</span>
        </button>

      </mat-menu>
    </div>
  </div>
  <div *ngFor="let summary of summaries">
    <app-transaction-summary-invoice [currency]="currency" [dateIssued]="dateIssued"
                                     [summary]="summary" class="transaction-summary-invoice"
                                     id="{{summary.retailerCompanyName}}"></app-transaction-summary-invoice>
    <br/>
  </div>
</div>
